import axios from 'axios';
import { getBackendURL } from '../Utils/ServerURL';
import { STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_BY_BRAND, ORDER_ASCENDING } from '../Utils/Constants';
const sTransportManagementControllerEndpoint = 'TransportManagement';


export class TransportManagementAPI {

  getTransportsLots(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = ORDER_BY_BRAND, order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage,
      orderBy: orderBy,
      order: order
    }
    if (searchBy)
      params.searchBy = searchBy;
    return axios.get(getBackendURL() + sTransportManagementControllerEndpoint + '/GetTransportManagementLotsList', { params });
  }

  getTransportManagementCarsList(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '', negotiationLotId) {
    let params = {
      negotiationLotId: negotiationLotId,
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      params.searchBy = searchBy;
    if (orderBy)
      params.orderBy = orderBy;
    if (order)
      params.order = order;
    return axios.get(getBackendURL() + sTransportManagementControllerEndpoint + '/GetTransportManagementDataByLot', { params });
  }

  getTransportManagementCarsListWRT(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      params.searchBy = searchBy;
    if (orderBy)
      params.orderBy = orderBy;
    if (order)
      params.order = order;
    return axios.get(getBackendURL() + sTransportManagementControllerEndpoint + '/GetWaitingTransportL4', { params });
  }

  getTransportManagementCarsListWAD(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      params.searchBy = searchBy;
    if (orderBy)
      params.orderBy = orderBy;
    if (order)
      params.order = order;
    return axios.get(getBackendURL() + sTransportManagementControllerEndpoint + '/GetWaitingArrivalL4', { params });
  }

  getTransportManagementCarsListAtD(page = STARTING_TABLE_PAGE, rowsPerPage = DEFAULT_ROWS_PER_PAGE, orderBy = '', order = ORDER_ASCENDING, searchBy = '') {
    let params = {
      page: page,
      rowsPerPage: rowsPerPage
    }
    if (searchBy)
      params.searchBy = searchBy;
    if (orderBy)
      params.orderBy = orderBy;
    if (order)
      params.order = order;
    return axios.get(getBackendURL() + sTransportManagementControllerEndpoint + '/GetOnDestinyL4', { params });
  }

  updateTransportManagementCarInfo(dto) {
    return axios.put(getBackendURL() + sTransportManagementControllerEndpoint + '/UpdateTransportManagementCarInfo', dto);
  }

}

export default TransportManagementAPI


// WEBPACK FOOTER //
// ./src/API/TransportManagementAPI.js